import { memo } from 'react';
import { formatNumber } from '@betty/toolkit/utils';
import { Box, Text, ProgressBar } from '@betty/moonlight';
import { BonusProgressProps } from './BonusProgress.types';

function BonusProgress({ progress, ...rest }: BonusProgressProps) {
  return (
    <Box flexDirection="row" gap="space-200" alignItems="center" {...rest}>
      <ProgressBar
        flex={1}
        from={0}
        to={100}
        progress={progress}
        backgroundColor="secondaryBackground"
      />
      <Box flexDirection="row" gap="space-100" centerContent>
        <Text variant="body-s-semi" gradient="darkSurfaceAccent">
          {formatNumber(progress / 100, { style: 'percent' })}
        </Text>
        <Text
          variant="body-s"
          locKey="done"
          locNS="onboarding"
          color="darkSurfacePrimary"
        />
      </Box>
    </Box>
  );
}

export default memo(BonusProgress);
